"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("../Layouts/AppLayout"));
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
var page_1 = require("@syncfusion/ej2-grids/src/grid/actions/page");
var inertia_1 = require("@inertiajs/inertia");
var Label_1 = __importDefault(require("../Jetstream/Label"));
var ej2_react_dropdowns_1 = require("@syncfusion/ej2-react-dropdowns");
var ej2_react_inputs_1 = require("@syncfusion/ej2-react-inputs");
var Button_1 = __importDefault(require("../Jetstream/Button"));
var formatters_1 = require("@/utils/formatters");
var Points = /** @class */ (function (_super) {
    __extends(Points, _super);
    function Points(props) {
        var _this = _super.call(this, props) || this;
        _this.getContacts = function () {
            return _this.props.contacts.map(function (contact) {
                return {
                    value: contact.id,
                    text: contact.name + ' (' + contact.tax_number + ')',
                };
            });
        };
        _this.getReason = function () {
            return '';
        };
        _this.getToolbarOptions = function () {
            var options = [];
            if (_this.canSubmitPoints()) {
                options.push({
                    text: 'Add Points',
                    id: 'add',
                    click: function () {
                        _this.setState({ isOpen: true });
                    },
                });
            }
            if (_this.canApprovePoints()) {
                options.push({
                    text: 'Approve Points',
                    id: 'approve',
                    disabled: true,
                    click: function () {
                        _this.submitBulk('approve');
                    },
                }, {
                    text: 'Resend Points',
                    id: 'resend',
                    disabled: true,
                    click: function () {
                        _this.submitBulk('resend');
                    },
                }, {
                    text: 'Decline Points',
                    id: 'decline',
                    disabled: true,
                    click: function () {
                        _this.submitBulk('decline');
                    },
                });
            }
            return options;
        };
        _this.selectedItems = [];
        _this.gridInstance = null;
        _this.gridRowSelected = function () {
            _this.syncToolbarState();
        };
        _this.gridRowDeselected = function () {
            _this.syncToolbarState();
        };
        _this.closeModal = function () {
            _this.setState({
                isOpen: false,
            });
        };
        _this.formatStatus = function (_field, data) {
            return (0, formatters_1.humanizeStatus)(typeof (data === null || data === void 0 ? void 0 : data.status) === 'string' ? data.status : '');
        };
        _this.submitBulk = function (action) {
            if (!_this.canApprovePoints()) {
                return;
            }
            var items = _this.getSelectedRecords();
            if (!items.length) {
                return;
            }
            var actionLabel = action === 'resend' ? 'Resend' : action === 'approve' ? 'Approve' : 'Decline';
            if (!window.confirm("".concat(actionLabel, " ").concat(items.length, " selected record(s)?"))) {
                return;
            }
            _this.setState({ isProcessing: true }, _this.syncToolbarState);
            inertia_1.Inertia.post('/points/bulk', {
                _method: 'PUT',
                action: action,
                ids: items.map(function (item) { return item.id; }),
            }, {
                preserveScroll: true,
                onSuccess: function () {
                    _this.setState({
                        actionMessage: 'Points updated.',
                        actionError: '',
                    });
                    inertia_1.Inertia.reload({ only: ['points'] });
                },
                onError: function (errors) {
                    var firstError = Object.values(errors || {})[0];
                    _this.setState({
                        actionMessage: '',
                        actionError: typeof firstError === 'string' ? firstError : 'Update failed.',
                    });
                },
                onFinish: function () {
                    _this.setState({ isProcessing: false }, _this.syncToolbarState);
                },
            });
        };
        _this.save = function () {
            if (!_this.canSubmitPoints()) {
                _this.setState({
                    error: 'You do not have permission to submit points.',
                });
                return;
            }
            if (_this.form.points && _this.form.contact_id && _this.form.reward_id) {
                inertia_1.Inertia.post('/points', {
                    id: null,
                    points: _this.form.points,
                    statement_text: 'Added points',
                    contact_id: _this.form.contact_id,
                    reward_id: _this.form.reward_id,
                }, {
                    preserveScroll: true,
                    onSuccess: function () {
                        _this.setState({
                            isOpen: false,
                            actionMessage: 'Points created.',
                            actionError: '',
                        });
                    },
                    onError: function (errors) {
                        var firstError = Object.values(errors || {})[0];
                        _this.setState({
                            actionMessage: '',
                            actionError: typeof firstError === 'string' ? firstError : 'Create failed.',
                        });
                    },
                });
            }
            else {
                _this.setState({
                    error: 'Missing Contact or Reward with a valid points!',
                });
            }
        };
        _this.getSelectedRecords = function () {
            var _a, _b;
            return ((_b = (_a = _this.gridInstance) === null || _a === void 0 ? void 0 : _a.getSelectedRecords) === null || _b === void 0 ? void 0 : _b.call(_a)) || [];
        };
        _this.syncToolbarState = function () {
            var _a;
            if (!((_a = _this.gridInstance) === null || _a === void 0 ? void 0 : _a.toolbarModule)) {
                return;
            }
            var items = _this.getSelectedRecords();
            _this.selectedItems = items;
            var hasAwaiting = items.some(function (item) { return item.status === 'awaiting_approval'; });
            var hasFailed = items.some(function (item) { return item.status === 'failed'; });
            var canMutate = !_this.state.isProcessing;
            if (_this.canApprovePoints()) {
                _this.gridInstance.toolbarModule.enableItems(['approve'], canMutate && hasAwaiting);
                _this.gridInstance.toolbarModule.enableItems(['decline'], canMutate && hasAwaiting);
                _this.gridInstance.toolbarModule.enableItems(['resend'], canMutate && hasFailed);
            }
        };
        _this.canSubmitPoints = function () {
            var _a;
            var role = (_a = _this.props.user) === null || _a === void 0 ? void 0 : _a.role;
            return role === 'admin' || role === 'submitter';
        };
        _this.canApprovePoints = function () {
            var _a;
            var role = (_a = _this.props.user) === null || _a === void 0 ? void 0 : _a.role;
            return role === 'admin' || role === 'approver';
        };
        _this.handleChange = function (event) {
            // @ts-ignore
            switch (event.target.id) {
                case 'points':
                    _this.form.points = event.target.value;
                    break;
                case 'statement_text':
                    _this.form.statement_text = event.target.value;
                    break;
                case 'contact':
                    _this.form.contact_id = event.target.itemData.value;
                    break;
                case 'reward':
                    _this.form.reward_id = event.target.itemData.id;
                    break;
            }
        };
        _this.getRewards = function () {
            return _this.props.rewards.map(function (reward) {
                return {
                    id: reward.id,
                    text: reward.title,
                };
            });
        };
        _this.state = {
            isOpen: false,
            error: '',
            isProcessing: false,
            actionError: '',
            actionMessage: '',
        };
        _this.form = {
            contact_id: null,
            reward_id: null,
            points: null,
            date: null,
            statement_text: null,
        };
        return _this;
    }
    Points.prototype.render = function () {
        var _this = this;
        var gridExtras = {
            loadingIndicator: { indicatorType: 'Spinner' },
            emptyRecordTemplate: function () { return (react_1.default.createElement("span", { className: "text-gray-500" }, "No points found.")); },
        };
        return (react_1.default.createElement(AppLayout_1.default, { title: "Points", renderHeader: function () { return (react_1.default.createElement("h2", { className: "font-semibold text-xl text-gray-800 leading-tight" }, "Points")); } },
            react_1.default.createElement("div", { className: "py-12" },
                react_1.default.createElement("div", { className: "mx-auto sm:ps-6 lg:px-8" },
                    react_1.default.createElement("div", { className: "bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" },
                        react_1.default.createElement("div", { className: "flex items-center justify-between" },
                            react_1.default.createElement("span", null, "Points"),
                            react_1.default.createElement("div", { className: "flex items-center gap-3 text-sm text-gray-500" },
                                this.state.isProcessing ? react_1.default.createElement("span", null, "Updating\u2026") : null,
                                this.state.actionMessage ? (react_1.default.createElement("span", { className: "text-green-600" }, this.state.actionMessage)) : null,
                                this.state.actionError ? (react_1.default.createElement("span", { className: "text-red-600" }, this.state.actionError)) : null)),
                        react_1.default.createElement(ej2_react_grids_1.GridComponent, __assign({ id: "grid", dataSource: this.props.points, toolbar: this.getToolbarOptions() }, gridExtras, { pageSettings: { pageSize: 25 }, allowPaging: true, allowSorting: true, allowFiltering: true, allowTextWrap: true, allowSelection: true, selectionSettings: { type: 'Multiple', checkboxOnly: true }, sortSettings: {
                                columns: [{ field: 'created_at', direction: 'Descending' }],
                            }, rowSelected: this.gridRowSelected, rowDeselected: this.gridRowDeselected, ref: function (g) { return (_this.gridInstance = g); } }),
                            react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { type: "checkbox", width: "40" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "contact.name", headerText: "Name", width: "200" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "points", headerText: "Points", width: "50", textAlign: "Right" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "statement_text", headerText: "Details", width: "300" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "sent_at", headerText: "Date Sent", width: "55", format: "dd/MM/yyyy", type: "date" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "created_at", headerText: "Date Created", width: "55", format: "dd/MM/yyyy", type: "date" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "status", headerText: "Status", width: "120", valueAccessor: this.formatStatus }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "request_response.errorMessage", headerText: "Error Message", width: "400" })),
                            react_1.default.createElement(ej2_react_grids_1.Inject, { services: [page_1.Page, ej2_react_grids_1.Toolbar, ej2_react_grids_1.Sort, ej2_react_grids_1.Filter, ej2_react_grids_1.Selection] }))))),
            this.state.isOpen && (react_1.default.createElement("div", { className: "fixed z-10 inset-0 overflow-y-auto ease-out duration-400" },
                react_1.default.createElement("div", { className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" },
                    react_1.default.createElement("div", { className: "fixed inset-0 transition-opacity" },
                        react_1.default.createElement("div", { className: "absolute inset-0 bg-gray-500 opacity-75" }, "Title")),
                    react_1.default.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen" }),
                    react_1.default.createElement("div", { className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full", role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-headline" },
                        react_1.default.createElement("form", null,
                            react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6 py-2 px-4 " },
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Add Points")),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Customer"),
                                    react_1.default.createElement(ej2_react_dropdowns_1.DropDownListComponent, { id: "contact", popupHeight: "200px", dataSource: this.getContacts(), value: this.form.contact_id, onChange: this.handleChange })),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Reward"),
                                    react_1.default.createElement(ej2_react_dropdowns_1.DropDownListComponent, { id: "reward", popupHeight: "200px", dataSource: this.getRewards(), value: this.form.reward_id, onChange: this.handleChange })),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement(Label_1.default, null, "Points"),
                                    react_1.default.createElement(ej2_react_inputs_1.NumericTextBoxComponent, { decimals: 0, format: "#,###", value: this.form.points, id: "points", onChange: this.handleChange, min: 1 })),
                                react_1.default.createElement("div", { className: "col-span-12" },
                                    react_1.default.createElement("div", { className: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" },
                                        react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                            react_1.default.createElement(Button_1.default, { onClick: this.save, type: "button", className: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Save")),
                                        react_1.default.createElement("span", { className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto" },
                                            react_1.default.createElement(Button_1.default, { onClick: this.closeModal, type: "button", className: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5" }, "Cancel")),
                                        react_1.default.createElement("span", { className: "p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" }, this.state.error)))))))))));
    };
    return Points;
}(react_1.default.Component));
exports.default = Points;
